import * as ActionTypes from "constants/ActionTypes";
import { combineReducers } from "redux";

function userDropdownVisible(state = false, action) {
  switch (action.type) {
    case ActionTypes.SET_USER_DROPDOWN_VISIBLE:
      return !state;
    default:
      return state;
  }
}

export default combineReducers({
  userDropdownVisible,
});
